import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Link, Navigate } from 'react-router-dom';

export function Landing() {
  return (
    <main className="page page-centered">
      <div className="card card-narrow">
        <h1>GroupPulse</h1>
        <p className="muted">Real-time leads from Facebook groups.</p>
        <SignedIn>
          <Navigate to="/dashboard" replace />
        </SignedIn>
        <SignedOut>
          <div className="actions">
            <Link className="btn btn-primary" to="/sign-in">
              Sign in
            </Link>
          </div>
        </SignedOut>
      </div>
    </main>
  );
}
